export const environment = {
  production: false,
  apiUrl: 'https://dashboard.perzeptron.de',
};